"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveOptions = exports.PINOption = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function PINOption(_) {
    return (react_1.default.createElement("span", { style: { display: "none" } }));
}
exports.PINOption = PINOption;
/* For usage without TypeScript */
PINOption.propTypes = {
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]).isRequired,
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    key: prop_types_1.default.any
};
function retrieveOptions(children, fallbackOptions) {
    var _a, _b;
    var usedFallbackOptions = (_a = fallbackOptions === null || fallbackOptions === void 0 ? void 0 : fallbackOptions.map(function (option) {
        var _a;
        return ({
            label: (_a = option.label) !== null && _a !== void 0 ? _a : option.value,
            value: option.value
        });
    })) !== null && _a !== void 0 ? _a : [];
    if (children != null) {
        return (_b = react_1.default.Children.map(children, function (child) {
            if (!react_1.default.isValidElement(child)) {
                return null;
            }
            return { label: child.props.label, value: child.props.value };
        })) === null || _b === void 0 ? void 0 : _b.filter(function (child) { return child != null; });
    }
    else {
        return usedFallbackOptions;
    }
}
exports.retrieveOptions = retrieveOptions;
//# sourceMappingURL=PINOption.js.map